<template>
    <section class="section our-goal ptb_100">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-12 col-lg-6">
                    <!-- Goal Content -->
                    <div class="goal-content section-heading text-center text-lg-left pr-md-4 mb-0">
                        <h2 class="mb-3">Vizija</h2>
                        <p>Blisko sarađujemo sa klijentima kako bismo maksimalno unapredili transformacioni pristup koji ima za cilj da koristi svim zainteresovanim stranama – osnažujući organizacije da rastu, grade održivu konkurentsku prednost i podstiču pozitivan društveni uticaj. Naš tim strastven je u razotkrivanju potencijala i ostvarivanju promena, isporučujući integrisana rešenja kroz upravljanje, konsalting, tehnologiju, kao i korporativne i digitalne poduhvate.</p>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <!-- Goal Thumb -->
                    <div class="goal-thumb mt-5 mt-lg-0">
                        <img src="assets/img/about_thumb_2.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
